window._ = require("lodash");

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.Vue = require("vue").default;

import PortalVue from 'portal-vue'

Vue.use(PortalVue)

Vue.prototype.svg = require("./svg");

import "lazysizes";

import VueAnimate from "vue-animate-scroll";
Vue.use(VueAnimate);
Vue.use(require('vue-cookies'))
const files = require.context("./", true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default
    )
);

new Vue({
    el: "#app",
    mounted() {
        let self = this;
        window.onscroll = function() {
            self.scrollFunction();
        };
    },
    methods: {
        scrollFunction() {
            const header = document.querySelector(".main-header");
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                header.classList.add("scrolled");
            } else {
                header.classList.remove("scrolled");
            }
        }
    }
});
